<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="d-flex align-items-center">
          <div class="m-r-10">
            <span class="btn btn-circle btn-lg bg-danger">
              <i class="ti-clipboard text-white"></i>
            </span>
          </div>
          <div class="pl-3">{{$t("page.content_dashboard.cursos.cursos_presenciales.title")}}</div>
          <div class="ml-auto">
            <div
              v-if="datos.total_cursos_programados_esta_semana == null"
              class="d-flex justify-content-center"
            >
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
            <h2 class="m-b-0 font-light" v-else>
              {{ datos.total_cursos_programados_esta_semana }}
            </h2>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="d-flex align-items-center">
          <div class="m-r-10">
            <span class="btn btn-circle btn-lg btn-info">
              <i class="ti-wallet text-white"></i>
            </span>
          </div>
          <div class="pl-3">{{$t("page.content_dashboard.cursos.acreditaciones_vencer.title")}}</div>
          <div class="ml-auto">
            <div
              v-if="vencimientosCargando"
              class="d-flex justify-content-center"
            >
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
            <h2 class="m-b-0 font-light" v-else>
              {{ datos.total_cursos_proximos_vencer }}
            </h2>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="d-flex align-items-center">
          <div class="m-r-10">
            <span class="btn btn-circle btn-lg bg-success">
              <i class="fas fa-laptop text-white"></i>
            </span>
          </div>
          <div class="pl-3">{{$t("page.content_dashboard.cursos.cursos_presenciales_mes.title")}}</div>
          <div class="ml-auto">
            <div
              v-if="datos.total_cursos_impartidos_mes == null"
              class="d-flex justify-content-center"
            >
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
            <h2 class="m-b-0 font-light" v-else>
              {{ datos.total_cursos_impartidos_mes }}
            </h2>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      datos: {
        total_cursos_programados_esta_semana: null,
        total_cursos_proximos_vencer: 0,
        total_cursos_impartidos_mes: null,
        total_costos_cursos: null,
      },
      vencimientosCargando: true,
    };
  },
  methods: {
    parseJsonResponse(respuesta) {
      if (respuesta && respuesta.body !== undefined && respuesta.body !== null && respuesta.body !== '') {
        return typeof respuesta.body === 'object' ? respuesta.body : JSON.parse(respuesta.body);
      }
      if (respuesta && typeof respuesta.json === 'function') {
        return respuesta.json();
      }
      return respuesta;
    },
    Consultar() {
      this.$http
        .get("dashboard/cards")
        .then((respuesta) => this.parseJsonResponse(respuesta))
        .then((respuestaJson) => {
          this.datos.total_cursos_programados_esta_semana =
            respuestaJson.total_cursos_programados_esta_semana;
          this.datos.total_cursos_impartidos_mes =
            respuestaJson.total_cursos_impartidos_mes;
          this.datos.total_costos_cursos = respuestaJson.total_costos_cursos;
          if (
            respuestaJson.total_cursos_proximos_vencer !== undefined &&
            respuestaJson.total_cursos_proximos_vencer !== null
          ) {
            this.datos.total_cursos_proximos_vencer =
              respuestaJson.total_cursos_proximos_vencer;
            this.vencimientosCargando = false;
          }
        })
        .catch(() => {
          this.datos.total_cursos_programados_esta_semana = 0;
          this.datos.total_cursos_impartidos_mes = 0;
          this.datos.total_costos_cursos = 0;
        });
      this.ConsultarVencimientos();
    },
    ConsultarVencimientos() {
      this.vencimientosCargando = true;
      this.$http
        .get("dashboard/admin-vencimientos", { timeout: 120000 })
        .then((respuesta) => this.parseJsonResponse(respuesta))
        .then((respuestaJson) => {
          const total =
            respuestaJson && respuestaJson.total_cursos_proximos_vencer;
          this.datos.total_cursos_proximos_vencer =
            total !== undefined && total !== null ? total : 0;
          this.vencimientosCargando = false;
        })
        .catch(() => {
          this.datos.total_cursos_proximos_vencer = 0;
          this.vencimientosCargando = false;
        });
    },
  },
  created() {
    this.Consultar();
  },
};
</script>

<style scoped>
.bg-danger {
  background-color: #ff3300 !important;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/AppLms/Dashboard/Vistas_Por_Perfil/Administrador.vue